<template>
    <layout-modal
        ref="modal"
        size="max-w-lg"
        @closing="saveCloseCookie()"
    >
        <template #title>
            <span>
                {{
                    $t("portal.card.re_add_wallet.title", {
                        year: year,
                    })
                }}
            </span>
        </template>

        <div class="flex flex-col gap-y-8 p-4">
            <div class="flex flex-col items-center">
                <p class="text-larger leading-6">
                    {{
                        $t("portal.card.re_add_wallet.description", {
                            year: year,
                            status: loyaltyStatus,
                        })
                    }}
                </p>

                <div class="flex justify-center gap-4 mt-12">
                    <a
                        :href="baseUrl + 'api/wallet/google/v1/download'"
                        @click="cookieStore.trackEvent('wallet_download_google', { context: 'redownload' })"
                    >
                        <img
                            alt="Google Wallet"
                            class="h-12"
                            src="/images/wallet/google-wallet-add-de.svg"
                        />
                    </a>

                    <a
                        :href="baseUrl + 'api/wallet/apple/v1/download'"
                        class="focus:outline-none"
                        @click="cookieStore.trackEvent('wallet_download_apple', { wallet_context: 'redownload' })"
                    >
                        <img
                            alt="Apple Wallet"
                            class="h-12"
                            src="/images/wallet/apple-wallet-add-de.svg"
                        />
                    </a>
                </div>
            </div>
        </div>
    </layout-modal>
</template>

<script lang="ts" setup>
import { useCookies } from "@vueuse/integrations/useCookies";
import type { KadeweUser } from "~/types";
import type { LayoutModal } from "#components";

const baseUrl = useBaseUrl();
const user = useSanctumUser<KadeweUser>();
const { t } = useI18n();
const cookies = useCookies();
const cookieStore = useCookieStore();

const modal = ref<InstanceType<typeof LayoutModal>>();

const year = new Date().getFullYear();

onMounted(() => {
    const hasClosedCookie = cookies.get("wallet_redownload_closed") !== undefined;

    if (user.value?.show_old_pass_popup && !hasClosedCookie) {
        modal.value?.open();
        cookieStore.trackEvent("wallet_redownload_modal_shown");
    }
});

const loyaltyStatus = computed(() => {
    if (!user.value?.loyalty_status) {
        return "";
    }

    if (user.value.loyalty_status === "member") {
        return t("portal.status.status_classic");
    }

    return t(`portal.status.status_${user.value.loyalty_status}`);
});

/**
 * Save close state in a cookie for 3 months.
 */
const saveCloseCookie = () => {
    cookieStore.trackEvent("wallet_redownload_modal_closed");
    cookies.set("wallet_redownload_closed", "true", {
        expires: new Date(Date.now() + 90 * 24 * 60 * 60 * 1000), // 90 days
    });
};
</script>
